{
  "version": 1,
  "markers": [
    {
      "missionId": "mission.soldaten-i-boegen",
      "x": 0.6503,
      "y": 0.2823
    },
    {
      "missionId": "mission.bredballe-kirkebakken.bredballe",
      "x": 0.7609,
      "y": 0.3434
    },
    {
      "missionId": "mission.fjordenhus-arkitektens-sten",
      "x": 0.4851,
      "y": 0.5254
    },
    {
      "missionId": "mission.ny-opgave-2",
      "x": 0.4206,
      "y": 0.5158
    },
    {
      "missionId": "mission.vejle-vindmoelle.korset-paa-moellen",
      "x": 0.4126,
      "y": 0.6766
    },
    {
      "missionId": "mission.broen.den-forsvundne-landevej",
      "x": 0.8595,
      "y": 0.17
    },
    {
      "missionId": "mission.mestrenes-hjemmebane-d7dba3de",
      "x": 0.5453,
      "y": 0.3612
    },
    {
      "missionId": "mission.skihopbakken-i-skoven",
      "x": 0.6674,
      "y": 0.3844
    },
    {
      "missionId": "mission.munkebjerg-udsigt-paa-menuen-23fed41d",
      "x": 0.812,
      "y": 0.85
    },
    {
      "missionId": "mission.sct-nicolai.de-23-hoveder",
      "x": 0.3456,
      "y": 0.462
    },
    {
      "missionId": "mission.raadhustorvet.fire-erhverv",
      "x": 0.3874,
      "y": 0.5301
    },
    {
      "missionId": "mission.smidtske-gaard.aarstallet-over-porten",
      "x": 0.3542,
      "y": 0.5179
    }
  ]
}
